<template>
  <SPSliderSection
    class="best-trainers-section"
    :title="title"
    variant="white"
    :data="trainers"
    :class="ui?.root"
    :loading="loading"
    loader-border
    :container-class="ui?.container"
    :all-button="{
      label: 'Все тренеры',
      to: '/trainers',
    }"
    mobile-all-button
  >
    <template #default="{ slide }">
      <CommonCard
        :item="slide"
        :hover="['description']"
        :background="false"
        :padding="false"
        :to="`/trainers/${slide.id}`"
        image-top-left="direction"
        title-above-left="school"
        title-right="directions"
        :description-under-left="descriptionUnder"
        :hover-elements="['description']"
        footer
        :ui="{
          title: 'max-md:line-clamp-2',
        }"
        @register="openSignForClassModal($event)"
        @detail="$router.push(`/trainers/${$event}`)"
      />
    </template>
  </SPSliderSection>
</template>

<script lang="ts" setup>
import type { Trainer } from '~/api'
import { useModal } from '~/shared/modals'
import SignForClassModal from '../SignForClassModal.vue'
import { declOfNum, declOfNumWithVal } from '~/shared'
import type { IconWithLabel } from '~/types'

defineOptions({
  name: 'BestTrainersSection',
})

const props = withDefaults(
  defineProps<{
    trainers?: Trainer[]
    loading?: boolean
    title?: string
    full?: boolean
    hover?: boolean
    ui?: {
      root?: string
      container?: string
      card?: string
      cardBody?: string
      title?: string
      image?: string
      infoHeader?: string
      info?: string
      footer?: string
    }
  }>(),
  {
    title: 'Лучшие тренеры',
    full: true,
    hover: true,
  },
)

const pageStore = usePageStore()
const { mainPage } = storeToRefs(pageStore)
const trainers = computed(
  () => (props.trainers || mainPage.value?.trainers) ?? [],
)

const descriptionUnder: IconWithLabel[] = [
  {
    icon: 'i-local-graduation-cap',
    label: 'Мокпыт: ',
    value: declOfNumWithVal(24, [' год', ' года', ' лет']),
    iconClass: '',
  },
  {
    icon: 'i-local-award',
    label: 'Мокграды: ',
    value: `104 <span class="max-md:hidden">${declOfNum(104, [' награда', ' награды', ' наград'])}</span>`,
    iconClass: 'bg-warning-light',
  },
]

const openSignForClassModal = (id: string) => {
  const { open } = useModal(SignForClassModal, {
    props: {
      id,
      apiMethod: useTrainerStore().trainingSignup,
    },
  })

  open()
}
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 498px;
  --card-image-height: 414px;
  --card-hover-image-height: 254px;

  :deep(.body-header) {
    margin-bottom: 12px;
  }

  @include max-xl {
    --card-height: 408px;
    --card-image-height: 180px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 160px;

    :deep(.body-header) {
      display: none;
    }
  }
}

:deep(.info-header) {
  opacity: 1;
  max-height: unset;
  margin-bottom: 12px;
}
</style>
